import React, { useState } from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';

import { useNavigate, useLocation } from 'react-router-dom';

type ServiceItem = {
  number: string;
  title: string;
  image: string;
  Link: string;
};

const services: ServiceItem[] = [
  {
    number: 'I',
    title: 'COACHING',
    image: 'https://dprstorage.b-cdn.net/RW/servsmall1.png',
    Link: 'services/luxury-sales-coach',
  },
  {
    number: 'II',
    title: 'CONSULTING',
    image: 'https://dprstorage.b-cdn.net/RW/servsmall2.png',
    Link: 'services/luxury-sales-consulting',
  },
  {
    number: 'III',
    title: 'REALTY',
    image: 'https://dprstorage.b-cdn.net/RW/servsmall3.png',
    Link: 'services/realty',
  },
];

const ServicesSection: React.FC = () => {
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState<string | null>(null);
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [activeCard, setActiveCard] = useState<number | null>(null);

  const handleNavigate = (route: string) => {
    // Special handling for branding to avoid unnecessary component loading
    if (route === '/services/branding') {
      window.open(
        'https://dezignshark.com/services/digital-marketing-hyderabad',
        '_blank',
      );
      return;
    }

    navigate(route);
    setDropdownOpen(null);
    setMobileOpen(false);
    setActiveMenu(route); // Set the active menu item
  };

  // NEW: Only intercept clicks on the Branding CTA; everything else remains unchanged
  const handleCtaClick = (e: React.MouseEvent, service: ServiceItem) => {
    if (service.title === 'Branding') {
      e.stopPropagation();
      e.preventDefault();
      window.open(
        'https://dezignshark.com/services/digital-marketing-hyderabad',
        '_blank',
        'noopener,noreferrer',
      );
    }
    // For other services, do nothing here so the parent card's onClick handles navigation
  };

  return (
    <Box
      id="service"
      sx={{
        position: 'relative',
        py: { xs: 4, sm: 5, md: 6, lg: 8 },
        px: { xs: 2, sm: 3, md: 4 },
        background: {
          xs: '#ffffff',
          sm: 'linear-gradient(135deg, rgba(15, 99, 165, 0.05) 0%, rgba(28, 31, 38, 0.05) 100%)',
        },
        backdropFilter: { xs: 'none', sm: 'blur(10px)' },
        borderRadius: { xs: '12px', sm: '16px', md: '20px' },
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        mx: { xs: 1.5, sm: 2, md: 0 },
        mt: { xs: 3, sm: 0 },
      }}
    >
      {/* Header (unchanged) */}
      {/* ... your header code ... */}
      <Container maxWidth="xl">
        {/* /     Header */}
        {/* <Box
          sx={{
            mb: { xs: 5, sm: 4, md: 5 },
            py: { xs: 4, sm: 4, md: 5 },
            px: { xs: 2.5, sm: 3, md: 4 },
            textAlign: 'center',
            background: '#ffffff', // Solid white for mobile clarity
            borderRadius: { xs: '12px', sm: '10px', md: '12px' },
            border: '1px solid #e0e0e0',
            boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '30px', sm: '36px', md: '44px' },
              fontWeight: 700,
              color: '#1c1f26',
              mb: { xs: 2, sm: 1 },
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            What We Deliver
          </Typography>

         

          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: '15px', sm: '16px', md: '18px' },
              color: '#555',
              lineHeight: { xs: 1.6, sm: 1.5 },
              maxWidth: '900px',
              mx: 'auto',
              mb: 1,
              textAlign: 'center',
              px: { xs: 1, sm: 0 },
            }}
          >
            We support sales growth in two ways by Upskilling & Enabling Sales Professionals and Creating a Sales Mindset, by Luxury Sales Mastery Coaching and by executing Luxury Sales Consulting for Builders & Developers & Multiple Industries.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: { xs: '15px', sm: '16px', md: '18px' },
              color: '#555',
              lineHeight: { xs: 1.6, sm: 1.5 },
              maxWidth: '900px',
              mx: 'auto',
              mb: 3,
              textAlign: 'center',
              px: { xs: 1, sm: 0 },
            }}
          >
            Our work is practical, market-driven, and shaped by real world buyer conversations not mere theory.
          </Typography>
          <Box
            onClick={() => navigate('/services')}
            sx={{
              display: 'inline-block',
              px: { xs: 4, sm: 4 },
              py: { xs: 1.8, sm: 2 },
              background: '#0f63a5',
              color: '#fff',
              borderRadius: { xs: '30px', sm: '8px' }, // Rounded button on mobile
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              textTransform: 'uppercase',
              fontWeight: 600,
              fontSize: { xs: '14px', sm: '16px' },
              letterSpacing: '1px',
              boxShadow: {
                xs: '0 4px 10px rgba(15, 99, 165, 0.3)',
                sm: 'none',
              },
              mt: { xs: 1, sm: 0 },
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(15, 99, 165, 0.3)',
              },
              '&:active': {
                transform: 'translateY(1px)',
                boxShadow: '0 2px 10px rgba(15, 99, 165, 0.2)',
              },
            }}
          >
            View All Services
          </Box>
        </Box> */}
         <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '30px', sm: '36px', md: '44px' },
              fontWeight: 700,
              color: '#1c1f26',
              mb: { xs: 2, md:3 },
              textTransform: 'uppercase',
              letterSpacing: '1px',
            }}
          >
            What We Deliver
          </Typography>

        {/* Services List */}
        <Grid
          container
          spacing={{ xs: 1.5, sm: 3, md: 4, lg: 5 }}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'stretch',
            maxWidth: '100%',
            mx: 'auto',
            // mb: { xs: 2, sm: 5, md: 6, lg: 8 },
            // pb: { xs: 1, sm: 4, md: 5 },
          }}
        >
          {services.map((service, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={service.title}
              sx={{ mb: { xs: 0.5, sm: 0 } }}
            >
              <Box
                onClick={() => navigate(`/${service.Link}`)}
                onMouseEnter={() => setActiveCard(index)}
                onMouseLeave={() => setActiveCard(null)}
                onTouchStart={() => setActiveCard(index)}
                onTouchEnd={() => setTimeout(() => setActiveCard(null), 800)}
                sx={{
                  position: 'relative', // important for the local preview
                  height: {xs:"auto",md:"auto",lg:"'320px'"},
                  background: {
                    xs: '#ffffff',
                    sm: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(248, 249, 250, 0.8) 100%)',
                  },
                  backdropFilter: { xs: 'none', sm: 'blur(10px)' },
                  borderRadius: { xs: '8px', sm: '10px', md: '12px' },
                  border: {
                    xs: '1px solid #e0e0e0',
                    sm: '1px solid rgba(255, 255, 255, 0.3)',
                  },
                  p: { xs: 2, sm: 2.5, md: 3 },
                  cursor: 'pointer',
                  transition: 'all 0.25s ease',
                  boxShadow: {
                    xs: '0 2px 10px rgba(0,0,0,0.08)',
                    sm: '0 4px 20px rgba(0,0,0,0.1)',
                  },
                  display: 'flex',
                  flexDirection: 'column',
                  '&:hover': {
                    transform: {
                      xs: 'translateY(-2px)',
                      sm: 'translateY(-4px)',
                    },
                    borderColor: '#0f63a5',
                    border: {
                      xs: '2px solid #0f63a5',
                      sm: '1px solid #0f63a5',
                    },
                    boxShadow: {
                      xs: '0 8px 20px rgba(15, 99, 165, 0.15)',
                      sm: '0 12px 40px rgba(15, 99, 165, 0.2)',
                    },
                    background: {
                      xs: '#ffffff',
                      sm: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.9) 100%)',
                    },
                  },
                  '&:active': {
                    transform: 'translateY(0)',
                    boxShadow: '0 2px 10px rgba(15, 99, 165, 0.1)',
                  },
                }}
              >
                {/* Local hover preview (above this card) */}
                {/* <Box
                  sx={{
                    position: 'absolute',
                    left: '50%',
                    top: { xs: -210, sm: -220, md: -240 }, // sits above the card
                    transform: 'translateX(-50%)',
                    width: { xs: 220, sm: 240, md: 260, lg: 280 },
                    height: { xs: 240, sm: 260, md: 300, lg: 320 },
                    borderRadius: { xs: '10px', sm: '10px', md: '12px' },
                    backgroundImage: `url(${service.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    boxShadow: {
                      xs: '0 4px 30px rgba(0,0,0,0.25)',
                      sm: '0 6px 25px rgba(0,0,0,0.18)',
                      md: '0 10px 30px rgba(0,0,0,0.2)',
                    },
                    border: { xs: '3px solid #ffffff', sm: 'none' },
                    pointerEvents: 'none',
                    zIndex: 3,
                    opacity: activeCard === index ? 1 : 0,
                    visibility: activeCard === index ? 'visible' : 'hidden',
                    transition:
                      'opacity 0.25s ease, visibility 0.25s ease, transform 0.25s ease',
                    // subtle lift when visible
                    ...(activeCard === index
                      ? { transform: 'translateX(-50%) translateY(-6px)' }
                      : {}),
                  }}
                /> */}

                {/* Service Number */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: { xs: -10, sm: -12, md: -14 },
                    left: { xs: 10, sm: 14, md: 16 },
                    width: { xs: 24, sm: 30, md: 32 },
                    height: { xs: 24, sm: 30, md: 32 },
                    background:
                      'linear-gradient(135deg, #0f63a5 0%, #1c1f26 100%)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: { xs: '14px', sm: '15px', md: '16px' },
                    zIndex: 2,
                    boxShadow: { xs: '0 2px 6px rgba(0,0,0,0.15)', sm: 'none' },
                  }}
                >
                  {service.number}
                </Box>

                {/* Title */}
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: {
                      xs: '18px',
                      sm: '22px',
                      md: '26px',
                      lg: '28px',
                    },
                    fontWeight: 700,
                    color: '#1c1f26',
                    mb: { xs: 1, sm: 2, md: 2.5 },
                    mt: { xs: 0.3, sm: 0 },
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    textAlign: 'center',
                    transition: 'all 0.3s ease',
                    '&:hover': { color: '#0f63a5' },
                  }}
                >
                  {service.title}
                </Typography>

                {/* Description (use your existing copy) */}
             <Typography
  component="div"
  sx={{
    color: '#555',
    lineHeight: 1.6,
    textAlign: 'left',
    flexGrow: 1,
    overflow: 'visible',
  }}
>
  {service.title === 'COACHING' && (
    <>
      <Typography variant="body2" sx={{ mb: 1.5 }}>
        My team and I work with luxury and premium real estate sales teams to
        refine how they communicate, position value, and handle high-value
        buyer conversations with greater confidence and clarity.
      </Typography>

      <Typography variant="body2">
        Built from years of on-ground experience, these structured coaching
        programmes are designed to strengthen sales thinking, improve
        conversion quality, and create more consistent execution across the
        team.
      </Typography>
    </>
  )}

  {service.title === 'CONSULTING' && (
    <>
      <Typography variant="body2" sx={{ mb: 1.5 }}>
        We work closely with developers and sales organizations to assess
        existing systems, identify operational gaps, and build stronger sales
        and business development structures.
      </Typography>

      <Typography variant="body2">
        From positioning and process design to CRM implementation and execution
        refinement, our consulting engagements are focused on creating scalable
        systems that support long-term market performance.
      </Typography>
    </>
  )}

  {service.title === 'REALTY' && (
    <>
      <Typography variant="body2" sx={{ mb: 1.5 }}>
        For selected projects, we operate through an exclusive mandate model
        where my team and I take complete ownership of the project’s sales
        strategy and execution.
      </Typography>

      <Typography variant="body2">
        From market positioning and buyer experience to sales management,
        negotiations, reporting, and closures, we work as an embedded sales
        leadership partner focused on driving stronger project performance.
      </Typography>
    </>
  )}
</Typography>



                {/* CTA */}
                <Box
                  sx={{ display: 'flex', justifyContent: 'center', mt: 'auto' }}
                >
                  <Box
                    onClick={(e) => handleCtaClick(e, service)}
                    sx={{
                      px: { xs: 2, sm: 2, md: 2.5 },
                      py: { xs: 0.6, sm: 1, md: 1.25 },
                      background: { xs: '#f8f8f8', sm: 'transparent' },
                      border: '2px solid #0f63a5',
                      borderRadius: { xs: '5px', sm: '5px', md: '6px' },
                      color: '#0f63a5',
                      fontSize: {
                        xs: '12px',
                        sm: '12px',
                        md: '13px',
                        lg: '14px',
                      },
                      fontWeight: 600,
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      transition: 'all 0.25s ease',
                      boxShadow: {
                        xs: '0 2px 5px rgba(0,0,0,0.08)',
                        sm: 'none',
                      },
                      '&:hover': {
                        background: '#0f63a5',
                        color: '#fff',
                        transform: 'translateY(-1px)',
                      },
                      '&:active': { transform: 'translateY(1px)' },
                    }}
                  >
                    Learn More
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Spacer */}
      <Box sx={{ height: { xs: '5px', sm: '10px', md: '20px', lg: '20px' } }} />
    </Box>
  );
};

export default ServicesSection;
